import { CarrotPlan } from "../../../types/CarrotPlan"
import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { RetryConfig } from "../../../utils/ErrorHandling"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetCarrotPlans"

const loadCarrotPlansData = async (employeeId: number): Promise<Array<CarrotPlan>> => {
  return await client.getCarrotPlansForEmployee(employeeId)
}

export const getCarrotPlansCacheKey = (employeeId: number): (string | number)[] => [ENDPOINT, employeeId]

export default function useCarrotPlans(employeeId: number): UseQueryResult<Array<CarrotPlan>, ResponseError> {
  return useQuery<Array<CarrotPlan>, ResponseError>(
    getCarrotPlansCacheKey(employeeId),
    () => loadCarrotPlansData(employeeId),
    {
      ...RetryConfig
    }
  )
}
